module.exports = __webpack_public_path__ + "img/project_4.b09016bf.png";